
import { get } from './http'
import { getJson } from './commonApi'

export async function search(props) {
  // console.log('search props:', props)
  const { scope, searchString } = props
  const response = await get(`/companiesHouse/search/${scope}?search=${searchString}`)
  return getJson(await response.json())
}

export async function advancedCompanySearch(searchString) {
  const name_includes = `?name_includes=${encodeURIComponent(searchString)}`
  let type = "&type=plc"
  // type += "&type=ltd"
  const response = await get(`/companiesHouse/AdvancedSearchCompany/${name_includes}${type}`)
  return getJson(await response.json())
}

export async function getRandomCompany(totalResults, seed) {
  const response = await get(`/companiesHouse/random/company/${totalResults}/${seed}`)
  return getJson(await response.json())
}